export const SELF_ONBOARD_DEMO_USER_REQUEST = 'self_onboard_demo_user_request';
export const SELF_ONBOARD_DEMO_USER_SUCCESS = 'self_onboard_demo_user_success';
export const SELF_ONBOARD_DEMO_USER_FAILURE = 'self_onboard_demo_user_failure';
